import { EventEmitter } from '@angular/core';
import { ApiService } from "../api.service";
import { CommonService } from "../common.service";
import { ActivatedRoute, Router } from "@angular/router";
var CasePracticeAuthorizationChoiceComponent = (function () {
    function CasePracticeAuthorizationChoiceComponent(commonService, apiService, route, router) {
        this.commonService = commonService;
        this.apiService = apiService;
        this.route = route;
        this.router = router;
        this.onGoToNextStep = new EventEmitter();
        this.assetsRoute = "../../assets";
        //选人之后 个人头像才可以点击
        this.peopleClick = false;
        //多对话 暂停
        this.dialogPause = false;
    }
    CasePracticeAuthorizationChoiceComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.apiService.ajax({
            'type': 'get',
            'url': '/api/authRole/' + this.exerciseId
        }).subscribe(function (result) {
            _this.data = result;
            _this.roles = _this.data.roles;
            _this.peopleViewed = _this.data.completed;
            _this.peopleSubmited = _this.data.status;
            if (_this.peopleViewed !== 0) {
                for (var i = 0, len = _this.roles.length; i < len; i += 1) {
                    _this.index = _this.getIndexByConditionIdInLists(_this.roles, 'id', _this.peopleViewed);
                }
            }
            else {
                _this.index = _this.peopleViewed;
            }
            _this.choicePageInit();
        });
        this.apiService.ajax({
            'type': 'get',
            'url': '/api/taskBook/' + this.exerciseId
        }).subscribe(function (result) {
            _this.taskBook = result;
        });
        /*this.data = this.getMockData();
        this.roles = this.data.roles;
        this.peopleViewed = this.data.completed;
        this.peopleSubmited = this.data.status;
    
    
        this.choicePageInit();*/
    };
    CasePracticeAuthorizationChoiceComponent.prototype.ngAfterViewInit = function () {
        this.commonService.initPage({
            'backgroundColor': 'white'
        });
        this.initSlideEvent();
    };
    CasePracticeAuthorizationChoiceComponent.prototype.choicePageInit = function () {
        this.introductionBoxShow = false;
        this.chatBoxShow = false;
        this.figureShow = false;
        this.msgCharacter = 0;
        this.msgTimeout = null;
        this.reviewTimeout = null;
        if (this.peopleSubmited == 0 && this.currentRole !== '高朗') {
            this.choiceWrapShow = false;
            this.analysisWrapShow = false;
            this.clickable = false;
            this.slideable = false;
            this.reviewable = false;
            this.selectedPeople = -1;
            this.choiceInit();
            $('#wrap').css('background-image', 'url("../../assets/picture/casepracticeauthorization/bg2.png")');
        }
        else if (this.peopleSubmited == 0 && this.currentRole === '高朗') {
            this.choiceWrapShow = true;
            this.analysisWrapShow = false;
            this.clickable = true;
            this.slideable = false;
            this.reviewable = true;
            this.selectedPeople = -1;
            this.step = 3;
            $('#wrap').css('background-image', 'url("../../assets/picture/casepracticeauthorization/bg1.png")');
        }
        else if (this.peopleSubmited > 0) {
            var _this = this;
            this.choiceWrapShow = false;
            this.clickable = false;
            this.reviewable = false;
            this.slideable = false;
            $('#choiceBtn').hide();
            var idx = void 0;
            for (var i = 0, len = this.roles.length; i < len; i += 1) {
                idx = this.getIndexByConditionIdInLists(this.roles, 'id', this.peopleSubmited);
            }
            this.selectedPeople = idx;
            this.currentRole = this.roles[this.selectedPeople].name;
            this.authRoleId = this.roles[this.selectedPeople].id;
            this.analysisText = this.roles[this.selectedPeople].why;
            $('#wrap').css('background-image', 'url("../../assets/picture/casepracticeauthorization/bg1.png")');
            if (this.currentRole == '高朗') {
                this.step = 202;
                $('#gl').fadeIn(200);
                this.analysisWrapShow = true;
                this.currentWord = this.roles[this.selectedPeople].why;
                this.analysisText = this.roles[this.selectedPeople].why;
                this.msgCharacter = 0;
                this.showFullText($("#analysisText"));
            }
            else {
                this.step = 201;
                $(this.getDomIdByName(this.currentRole)).fadeIn(200);
                $(this.getDomIdByName(this.currentRole)).addClass('activeFigure');
                this.currentWord = this.roles[this.selectedPeople].why;
                this.analysisWrapShow = true;
                this.msgCharacter = 0;
                this.showFullText($("#analysisText"));
            }
        }
    };
    CasePracticeAuthorizationChoiceComponent.prototype.taskBookOut = function ($event) {
        $event.stopPropagation();
        this.clickable = false;
        $('#shade').fadeIn(50);
        $('#taskBookBox').fadeIn();
        $('#closeBtn2').fadeIn();
    };
    CasePracticeAuthorizationChoiceComponent.prototype.closeTip = function ($event) {
        $event.stopPropagation();
        this.clickable = true;
        $('#shade').fadeOut();
        $('#taskBookBox').fadeOut();
        $('#closeBtn2').fadeOut();
        // 恢复点击功能
    };
    CasePracticeAuthorizationChoiceComponent.prototype.initSlideEvent = function () {
        var startX, startY, moveEndX, moveEndY, X, Y;
        var _this = this;
        $("#innerWrap").on("touchstart", function (e) {
            startX = e.originalEvent.changedTouches[0].pageX;
            startY = e.originalEvent.changedTouches[0].pageY;
        });
        $("#innerWrap").on("touchmove", function (e) {
            moveEndX = e.originalEvent.changedTouches[0].pageX;
            moveEndY = e.originalEvent.changedTouches[0].pageY;
            X = moveEndX - startX;
            Y = moveEndY - startY;
            var w = X < 0 ? X * -1 : X; //x轴的滑动值
            var h = Y < 0 ? Y * -1 : Y; //y轴的滑动值
            // if(w > h){
            //                  //如果是在x轴中滑动
            //   event.preventDefault();
            // }
        });
        $("#innerWrap").on("touchend", function (e) {
            moveEndX = e.originalEvent.changedTouches[0].pageX;
            moveEndY = e.originalEvent.changedTouches[0].pageY;
            X = moveEndX - startX;
            Y = moveEndY - startY;
            var w = X < 0 ? X * -1 : X; //x轴的滑动值
            var h = Y < 0 ? Y * -1 : Y; //y轴的滑动值
            // if(w > h){                   //如果是在x轴中滑动
            //
            //   event.preventDefault();
            //
            // }
            if (X < -5 && w > h && _this.slideable) {
                if (_this.step == 1 || _this.step == 2) {
                    _this.screenClick();
                }
            }
        });
    };
    //根据条件在数组中获取下标
    CasePracticeAuthorizationChoiceComponent.prototype.getIndexByConditionIdInLists = function (Lists, condition, value) {
        return (Lists || []).findIndex(function (v) { return v[condition] === value; });
    };
    // 初始化
    CasePracticeAuthorizationChoiceComponent.prototype.choiceInit = function () {
        var _this = this;
        this.node = this.index;
        console.log(this.node);
        this.subNode = 0;
        this.currentRole = this.roles[this.node].name;
        this.currentDescription = this.roles[this.node].description;
        this.currentWord = this.roles[this.node].say[this.subNode];
        this.step = 1;
        setTimeout(function () {
            $(_this.getDomIdByName(_this.currentRole)).fadeIn(200);
            _this.introductionBoxShow = true;
        }, 500);
        setTimeout(function () {
            // $('#arrowRight').fadeIn(200);
            _this.clickable = true;
            _this.slideable = true;
        }, 1500);
    };
    CasePracticeAuthorizationChoiceComponent.prototype.screenClick = function () {
        //多对话继续
        if (this.dialogPause) {
            this.dialogPause = false;
            return false;
        }
        // console.log(this.step);
        if (!this.clickable) {
            return;
        }
        var _this = this;
        this.msgCharacter = 0;
        if (this.step == 1) {
            this.clickable = false;
            this.slideable = false;
            // this.step = 2;
            this.introductionBoxShow = false;
            // $('#arrowRight').fadeOut(200);
            this.chatBoxShow = true;
            setTimeout(function () {
                // 显示第一句动画
                _this.getLetterByLetter($(_this.getDomIdByName(_this.currentRole) + 'ChatText'));
            }, 500);
        }
        else if (this.step == 2) {
            this.clickable = false;
            this.slideable = false;
            var lastRoleDomId = this.getDomIdByName(this.currentRole);
            $(lastRoleDomId).fadeOut(200);
            this.chatBoxShow = false;
            // $("#arrowRight").fadeOut(200);
            // 清空文字
            $(this.getDomIdByName(this.currentRole) + 'ChatText').text("");
            this.apiService.ajax({
                'type': 'post',
                'url': '/api/authRoleRead/' + this.exerciseId,
                'data': {
                    'authrole_id': this.roles[this.node].id
                }
            }).subscribe(function (result) { });
            // 换人了
            if (this.node < this.roles.length - 1) {
                this.step = 1;
                this.node++;
                this.currentWord = this.roles[this.node].say[this.subNode];
                this.currentRole = this.roles[this.node].name;
                this.currentDescription = this.roles[this.node].description;
                // $(lastRoleDomId+'Chat').fadeOut(200);
                setTimeout(function () {
                    $(_this.getDomIdByName(_this.currentRole)).fadeIn(200);
                    // $('#introductionBox').fadeIn(200);
                    _this.introductionBoxShow = true;
                }, 500);
                setTimeout(function () {
                    // $("#arrowRight").fadeIn(200);
                    _this.clickable = true;
                    _this.slideable = true;
                }, 1500);
            }
            else {
                this.step = 3;
                setTimeout(function () {
                    // $("#arrowRight").fadeOut(200);
                    _this.choiceWrapShow = true;
                    $('#wrap').css('background-image', 'url("../../assets/picture/casepracticeauthorization/bg1.png")');
                    $('.portraitBtn').css('z-index', 10000);
                }, 500);
                setTimeout(function () {
                    _this.clickable = true;
                    _this.slideable = false;
                    _this.reviewable = true;
                }, 1500);
            }
        }
        else if (this.step == 101) {
            this.clickable = false;
            this.reviewable = false;
            this.introductionBoxShow = false;
            this.chatBoxShow = true;
            setTimeout(function () {
                _this.getLetterByLetter($(_this.getDomIdByName(_this.currentRole) + "ChatText"));
            }, 500);
        }
    };
    CasePracticeAuthorizationChoiceComponent.prototype.peopleReview = function (i) {
        if (!this.clickable || !this.reviewable) {
            return;
        }
        var _this = this;
        this.clickable = false;
        this.msgCharacter = 0;
        $('#numberWrap').fadeOut(10);
        // $('#choiceWrap').fadeOut(200)
        this.choiceWrapShow = false;
        this.node = i;
        this.subNode = 0;
        this.currentRole = this.roles[this.node].name;
        this.currentDescription = this.roles[this.node].description;
        this.currentWord = this.roles[this.node].say[this.subNode];
        this.step = 101;
        setTimeout(function () {
            $(_this.getDomIdByName(_this.currentRole)).fadeIn(200);
            _this.introductionBoxShow = true;
            $('#closeBtn').fadeIn(200);
        }, 500);
        this.reviewTimeout = setTimeout(function () {
            _this.introductionBoxShow = false;
            _this.chatBoxShow = true;
            setTimeout(function () {
                _this.getLetterByLetter($(_this.getDomIdByName(_this.currentRole) + "ChatText"));
            }, 500);
        }, 1500);
    };
    CasePracticeAuthorizationChoiceComponent.prototype.selectPeople = function ($event, i) {
        $event.stopPropagation();
        if (!this.clickable || !this.reviewable) {
            return;
        }
        this.selectedPeople = i;
    };
    CasePracticeAuthorizationChoiceComponent.prototype.close = function ($event) {
        $event.stopPropagation();
        var _this = this, lastRoleDomId = this.getDomIdByName(this.currentRole);
        clearTimeout(this.msgTimeout);
        clearTimeout(this.reviewTimeout);
        this.clickable = false;
        // this.slideable = false;
        this.step = 3;
        $(lastRoleDomId).fadeOut(200);
        $(lastRoleDomId + 'Chat').fadeOut(200);
        $(this.getDomIdByName(lastRoleDomId) + "ChatText").text("");
        $('#closeBtn').fadeOut(200);
        $('#numberWrap').fadeIn(200);
        // $('#introductionBox').fadeOut(200);
        this.introductionBoxShow = false;
        this.chatBoxShow = false;
        setTimeout(function () {
            _this.choiceWrapShow = true;
        }, 500);
        setTimeout(function () {
            _this.clickable = true;
        }, 1500);
    };
    CasePracticeAuthorizationChoiceComponent.prototype.submitSelectedPeople = function ($event) {
        this.peopleClick = true;
        var _this = this;
        $event.stopPropagation();
        if (this.selectedPeople < 0) {
            return;
        }
        this.clickable = false;
        this.reviewable = false;
        this.choiceWrapShow = false;
        this.currentRole = this.roles[this.selectedPeople].name;
        this.authRoleId = this.roles[this.selectedPeople].id;
        this.analysisText = this.roles[this.selectedPeople].why;
        this.choiceWrapShow = false;
        $('#choiceBtn').hide();
        this.msgCharacter = 0;
        $('.portraitBtn').css('z-index', 1);
        if (this.currentRole == '高朗') {
            this.step = 202;
            $('#gl').fadeIn(200);
            this.analysisWrapShow = true;
            this.currentWord = this.roles[this.selectedPeople].why;
            this.analysisText = this.roles[this.selectedPeople].why;
            this.msgCharacter = 0;
            this.getLetterByLetter($("#analysisText"));
        }
        else {
            this.step = 201;
            $(this.getDomIdByName(this.currentRole)).fadeIn(200);
            $(this.getDomIdByName(this.currentRole)).addClass('activeFigure');
            this.currentWord = this.roles[this.selectedPeople].why;
            this.analysisWrapShow = true;
            this.msgCharacter = 0;
            this.getLetterByLetter($("#analysisText"));
        }
        this.apiService.ajax({
            'type': 'post',
            'url': '/api/authRole/' + this.exerciseId,
            'data': {
                'authrole_id': this.authRoleId
            }
        }).subscribe(function (result) { });
    };
    CasePracticeAuthorizationChoiceComponent.prototype.switchFigure = function ($event) {
        if (this.peopleClick) {
            if (!this.figureShow && $event.target.className.indexOf("activeFigure4") > -1) {
                return false;
            }
            else if (this.figureShow && $event.target.className.indexOf("activeFigure3") > -1) {
                return false;
            }
            var _this_1 = this;
            clearTimeout(this.msgTimeout);
            this.msgCharacter = 0;
            this.figureShow = !this.figureShow;
            $("#analysisTextBox").fadeOut(200);
            $("#analysisText").text("");
            // this.analysisWrapShow = false;
            setTimeout(function () {
                if (_this_1.figureShow) {
                    _this_1.currentWord = _this_1.roles[_this_1.selectedPeople].why;
                    _this_1.analysisText = _this_1.currentWord;
                    $("#analysisTextBox").fadeIn(200);
                    $('.activeFigure4').css({ opacity: 0.5, bottom: '3.2rem', left: '0.5rem', transform: 'scale(0.7)' }).css('z-index', 9998);
                    $('.activeFigure3').css({ opacity: 1, bottom: '0.8rem', left: '2.25rem', transform: 'scale(1)' }).css('z-index', 9999);
                }
                else if (!_this_1.figureShow) {
                    _this_1.currentWord = _this_1.roles[_this_1.selectedPeople].correct;
                    _this_1.analysisText = _this_1.currentWord;
                    $("#analysisTextBox").fadeIn(200);
                    $('.activeFigure3').css({ opacity: 0.5, bottom: '3.2rem', left: '0.5rem', transform: 'scale(0.7)' }).css('z-index', 9998);
                    $('.activeFigure4').css({ opacity: 1, bottom: '0.8rem', left: '2.25rem', transform: 'scale(1)' }).css('z-index', 9999);
                }
                _this_1.showFullText($("#analysisText"));
            }, 500);
        }
    };
    CasePracticeAuthorizationChoiceComponent.prototype.goToQuestion = function ($event) {
        this.commonService.setOnceIno(this.commonService.getOnceValue(this.exerciseMetaId, 703)).subscribe();
        this.onGoToNextStep.emit(4);
    };
    CasePracticeAuthorizationChoiceComponent.prototype.getDomIdByName = function (name) {
        if (name == '秦飞') {
            return '#qf';
        }
        else if (name == '季宁') {
            return '#jn';
        }
        else if (name == '王立娜') {
            return '#wln';
        }
        else if (name == '方科科') {
            return '#fkk';
        }
        else if (name == '高朗') {
            return '#gl';
        }
    };
    CasePracticeAuthorizationChoiceComponent.prototype.getLetterByLetter = function (container) {
        var _this = this;
        this.msgTimeout = setTimeout(function () {
            if (_this.dialogPause) {
                _this.getLetterByLetter(container);
            }
            else {
                if (_this.currentWord.substring(_this.msgCharacter, _this.msgCharacter + 1) == "<") {
                    _this.msgCharacter += 5;
                }
                else {
                    _this.msgCharacter++;
                }
                var type = _this.currentWord.substring(0, _this.msgCharacter);
                container.html(type);
                _this.getLetterByLetter(container);
            }
            if (_this.msgCharacter == _this.currentWord.length) {
                if (_this.step == 201) {
                    clearTimeout(_this.msgTimeout);
                    setTimeout(function () {
                        _this.step = 202;
                        _this.currentWord = _this.roles[_this.selectedPeople].correct;
                        _this.msgCharacter = 0;
                        _this.analysisWrapShow = false;
                        container.text("");
                        $('#gl').addClass("activeFigure2");
                        // _this.figureShow = true;
                        setTimeout(function () {
                            // $('#gl').fadeIn(200);
                            _this.analysisText = _this.roles[_this.selectedPeople].correct;
                            _this.figureShow = true;
                            _this.analysisWrapShow = true;
                        }, 1000);
                        setTimeout(function () {
                            $('.activeFigure').css({ opacity: 0.5, bottom: '3.2rem', left: '0.5rem', transform: 'scale(0.7)' }).css('z-index', 9998);
                            $('#gl').fadeIn();
                            $('.activeFigure2').css('z-index', 9999);
                            _this.figureShow = false;
                        }, 1500);
                        setTimeout(function () {
                            _this.showFullText($("#analysisText"));
                            $('#reviewCommentBtn').fadeIn(200);
                            $('.activeFigure').removeClass('activeFigure').addClass('activeFigure3');
                            $('.activeFigure2').removeClass('activeFigure2').addClass('activeFigure4');
                        }, 2000);
                    }, 1000);
                }
                else if (_this.step == 202) {
                    clearTimeout(_this.msgTimeout);
                    setTimeout(function () {
                        $('#analysisBtn').fadeIn(200);
                    }, 500);
                    _this.step = 203;
                }
                else if (_this.step == 203) {
                    clearTimeout(_this.msgTimeout);
                    // _this.clickable = true;
                }
                else if (_this.subNode < _this.roles[_this.node].say.length - 1) {
                    _this.dialogPause = true;
                    _this.subNode++;
                    _this.currentWord = _this.roles[_this.node].say[_this.subNode];
                    _this.msgCharacter = 0;
                }
                else {
                    clearTimeout(_this.msgTimeout);
                    if (_this.step == 1) {
                        _this.step = 2;
                        setTimeout(function () {
                            _this.subNode = 0;
                            _this.msgCharacter = 0;
                            // $('#arrowRight').fadeIn(200);
                            _this.slideable = true;
                            _this.clickable = true;
                        }, 1000);
                    }
                    else if (_this.step == 101) {
                        _this.step = 102;
                        setTimeout(function () {
                            var lastRoleDomId = _this.getDomIdByName(_this.currentRole);
                            $(lastRoleDomId).fadeOut(200);
                            $(lastRoleDomId + 'Chat').fadeOut(200);
                            _this.chatBoxShow = false;
                            setTimeout(function () {
                                container.text("");
                                _this.choiceWrapShow = true;
                                $('#closeBtn').fadeOut(200);
                            }, 500);
                            setTimeout(function () {
                                _this.clickable = true;
                                _this.reviewable = true;
                                $('#numberWrap').fadeIn(200);
                            }, 1500);
                        }, 1000);
                    } // end of 101
                } // end of role equal
            } // end of if letter is finished
        }, 20); // end of setTimeout
    }; // end of getLetterByLetter
    CasePracticeAuthorizationChoiceComponent.prototype.showFullText = function (container) {
        clearTimeout(this.msgTimeout);
        container.html(this.currentWord);
        var _this = this;
        //显示授权按钮
        if (this.step == 202) {
            setTimeout(function () {
                $('#analysisBtn').fadeIn(200);
            }, 500);
            this.step = 203;
        }
        else if (this.step == 201) {
            setTimeout(function () {
                //copy show
                _this.step = 202;
                _this.currentWord = _this.roles[_this.selectedPeople].correct;
                _this.msgCharacter = 0;
                _this.analysisWrapShow = false;
                container.text("");
                $('#gl').addClass("activeFigure2");
                // _this.figureShow = true;
                setTimeout(function () {
                    // $('#gl').fadeIn(200);
                    _this.analysisText = _this.roles[_this.selectedPeople].correct;
                    _this.figureShow = true;
                    _this.analysisWrapShow = true;
                }, 1000);
                setTimeout(function () {
                    $('.activeFigure').css({ opacity: 0.5, bottom: '3.2rem', left: '0.5rem', transform: 'scale(0.7)' }).css('z-index', 9998);
                    $('#gl').fadeIn();
                    $('.activeFigure2').css('z-index', 9999);
                    _this.figureShow = false;
                }, 1500);
                setTimeout(function () {
                    _this.showFullText($("#analysisText"));
                    $('#reviewCommentBtn').fadeIn(200);
                    $('.activeFigure').removeClass('activeFigure').addClass('activeFigure3');
                    $('.activeFigure2').removeClass('activeFigure2').addClass('activeFigure4');
                }, 2000);
            }, 1000);
        }
    };
    return CasePracticeAuthorizationChoiceComponent;
}());
export { CasePracticeAuthorizationChoiceComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-authorization-choice/case-practice-authorization-choice.component.ts.pre-build-optimizer.js